import api from './api';
import { Courier, CourierFormData, CourierListItem } from '@/types/courier';

export const courierApi = {
    // Admin: Tüm kuryeleri listele
    async getAllCouriers(params?: {
        status?: string;
        vendorId?: string;
        limit?: number;
        offset?: number;
    }): Promise<{ couriers: CourierListItem[]; total: number; hasMore: boolean }> {
        try {
            console.log('📡 Calling GET /admin/couriers with params:', params);
            const response = await api.get('/admin/couriers', { params });
            console.log('📥 Response:', response.data);
            return response.data;
        } catch (error: any) {
            console.error('❌ Courier API Error:', error.response || error);
            throw new Error(
                error.response?.data?.error || 'Kurye listesi yüklenemedi'
            );
        }
    },

    // Admin: Kurye detayı getir
    async getCourier(courierId: string): Promise<Courier & { vendor?: any; recentDeliveries?: any[] }> {
        try {
            const response = await api.get(`/admin/couriers/${courierId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching courier:', error);
            throw new Error(error.response?.data?.error || 'Kurye yüklenemedi');
        }
    },

    // Admin: Yeni kurye oluştur
    async createCourier(
        courierData: CourierFormData
    ): Promise<Courier & { passwordResetLink?: string }> {
        try {
            const response = await api.post('/admin/couriers', courierData);
            return response.data;
        } catch (error: any) {
            console.error('Error creating courier:', error);
            const errorMessage =
                error.response?.data?.details ||
                error.response?.data?.error ||
                'Kurye oluşturulamadı';
            throw new Error(errorMessage);
        }
    },

    // Admin: Kurye güncelle
    async updateCourier(
        courierId: string,
        courierData: Partial<CourierFormData>
    ): Promise<Courier> {
        try {
            const response = await api.put(`/admin/couriers/${courierId}`, courierData);
            return response.data;
        } catch (error: any) {
            console.error('Error updating courier:', error);
            throw new Error(
                error.response?.data?.error || 'Kurye güncellenemedi'
            );
        }
    },

    // Admin: Kurye statusunu değiştir
    async updateCourierStatus(
        courierId: string,
        status: string
    ): Promise<{ success: boolean }> {
        try {
            const response = await api.put(`/admin/couriers/${courierId}/status`, {
                status,
            });
            return response.data;
        } catch (error: any) {
            console.error('Error updating courier status:', error);
            throw new Error(
                error.response?.data?.error || 'Durum güncellenemedi'
            );
        }
    },

    // Admin: Kurye sil
    async deleteCourier(courierId: string): Promise<{ success: boolean }> {
        try {
            const response = await api.delete(`/admin/couriers/${courierId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error deleting courier:', error);
            throw new Error(error.response?.data?.error || 'Kurye silinemedi');
        }
    },

    // Vendor: Kendi kuryeleri listesi
    async getVendorCouriers(vendorId: string): Promise<{ couriers: CourierListItem[] }> {
        try {
            const response = await api.get(`/admin/couriers/vendor/${vendorId}`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching vendor couriers:', error);
            throw new Error(
                error.response?.data?.error || 'Kuryet yüklenemedi'
            );
        }
    },

    // Vendor: Yeni kurye oluştur
    async createVendorCourier(
        vendorId: string,
        courierData: Omit<CourierFormData, 'vendorId'>
    ): Promise<Courier & { passwordResetLink?: string }> {
        try {
            const response = await api.post(`/admin/couriers/vendor/${vendorId}/create`, courierData);
            return response.data;
        } catch (error: any) {
            console.error('Error creating vendor courier:', error);
            throw new Error(
                error.response?.data?.error || 'Kurye oluşturulamadı'
            );
        }
    },

    // Courier: Bana atanan siparişler
    async getCourierOrders(courierId: string): Promise<{ orders: any[] }> {
        try {
            const response = await api.get(`/admin/couriers/courier/${courierId}/orders`);
            return response.data;
        } catch (error: any) {
            console.error('Error fetching courier orders:', error);
            throw new Error(
                error.response?.data?.error || 'Siparişler yüklenemedi'
            );
        }
    },
};
